export type CatalogPdfJobStatus = 'pending' | 'running' | 'done' | 'failed';

export type CatalogPdfJobTriggerType = 'manual' | 'cron';

export interface ICatalogPdfJobCounts {
  territories: number;
  producers: number;
  wines: number;
}

export interface ICatalogPdfJob {
  id: string;
  status: CatalogPdfJobStatus;
  trigger_type: CatalogPdfJobTriggerType;
  requested_by: string | null;
  requested_by_name: string | null;
  requested_at: string;
  started_at: string | null;
  completed_at: string | null;
  s3_key: string | null;
  download_url: string | null;
  error_message: string | null;
  data_snapshot_counts: ICatalogPdfJobCounts | null;
}

export const CATALOG_PDF_IN_FLIGHT_STATUSES: CatalogPdfJobStatus[] = ['pending', 'running'];
